import React from 'react'
import Action from '../../model/Action'
import { Entidade } from '../../model/Entidade'

export function setEntidades(
    dispatch: React.Dispatch<Action>, payload: Entidade[]
) {
    dispatch({ type: 'setEntidades', payload })
}

export function setTotal(
    dispatch: React.Dispatch<Action>, payload: number
) {
    dispatch({ type: 'setTotal', payload })
}

export function setIsLoading(
    dispatch: React.Dispatch<Action>, payload: boolean
) {
    dispatch({ type: 'setIsLoading', payload })
}

export function setCurrentEntidade(
    dispatch: React.Dispatch<Action>, payload: Entidade
) {
    dispatch({ type: 'setCurrentEntidade', payload })
}
